<template>
  <page-template>
    <template slot="page-content">
      <div class="tickets-page--template page-template overflow-x-hidden">
        <h1
          class="f1 mv0 h1 page-title lh-title mv0 lh-solid tl ttu is-blenny is-black"
          style="color: transparent; height: 0px"
        >
          Tickets
        </h1>
        <!-- page content -->
        <div class="relative z-content bg-beige">
          <div class="relative container-fluid">
            <!-- <div class="db dn-ns absolute top-0 chase-logo-pos mt2 mb3 ml4 ml0-ns mr0 mr4-ns">
              <div class="db relative">
                <img src="/assets/images/logos/chase-logo-svg.svg" class="db mw4 mb2 ml0 pl0">
                <span class="db f5 f6-ns ttu is-open-regular">Preferred Payment Partner</span>
              </div>
            </div> -->
          </div>

          <!-- three day -->
          <div class="relative pv4 container-fluid z-content">
            <section
              :id="page.three_day_section.slug"
              class="relative mw9 center mt4 mt0-ns pt2 pb3 pv4-ns"
              v-if="page.three_day_section.is_published"
            >
              <div class="flex relative mb2 mb3-ns tl flex-row items-center">
                <h2
                  class="f-page-hdr mv0 ttu is-blenny is-navy"
                  :id="page.three_day_section.slug"
                >
                  {{ page.three_day_section.title }}
                </h2>
                <!-- <div class="dn db-ns ml2 mt4">
                  <div class="db relative">
                    <img
                      src="/assets/images/logos/chase-logo-svg.svg"
                      class="db mw4 mb2 ml2 pl1"
                    />
                    <span class="db f5 f6-ns ttu is-open-regular">
                      &nbsp;&nbsp; Preferred Payment Partner
                    </span>
                  </div>
                </div> -->
              </div>
              <div class="row">
                <div
                  class="relative col-xs-12 col-sm-6 col-md-4 mb4"
                  v-for="(ticket, index) in page.three_day_section.tickets"
                  :key="'tix-column-' + index"
                  :id="ticket.slug"
                >
                  <div
                    class="relative pt1 pb0 ph3 ph3-ns"
                    :class="{
                      'bg-yellow border-yellow': index === 2,
                      'bg-teal border-teal': index !== 2,
                    }"
                  >
                    <div
                      class="relative flex flex-row justify-between mv3"
                      :class="{ '': index === 2 }"
                    >
                      <div
                        class="relative tl mw5 flex items-center w-50"
                        :class="{ 'w-col-lg-important': index === 2 }"
                      >
                        <div class="db w5" :class="{ 'w-col-lg-important': index === 2 }">
                          <h3
                            class="db w-100 f3 ttu is-tablet-regular"
                            :class="{ 'is-navy': index === 2, 'is-beige': index !== 2 }"
                          >
                            {{ ticket.title }}
                          </h3>
                          <span
                            v-if="ticket.sub_title"
                            class="db f4 mt2 is-tablet-regular"
                            :class="{ 'is-navy': index === 2, 'is-beige': index !== 2 }"
                            >{{ ticket.sub_title }}</span
                          >
                        </div>
                      </div>
                      <div
                        class="relative tr w-100"
                        :class="{ 'dn-important': index === 2 }"
                      >
                        <span class="f2 is-tablet-bold ttu is-beige">
                          {{ ticket.price
                          }}<span class="db ttu f5 is-tablet-regular">&nbsp;+fees</span>
                        </span>
                      </div>
                    </div>
                    <div class="relative mv3 tc">
                      <a
                        v-if="ticket.is_disabled"
                        class="db relative center w-100 pv3 btn-generic btn-disabled o-60"
                        target="_blank"
                        :title="ticket.title + ' On Sale 3/15'"
                      >
                        <span class="text">
                          {{ ticket.button_copy }}
                        </span>
                      </a>
                      <a
                        v-else-if="ticket.is_sold_out"
                        class="db relative center w-100 pv3 btn-generic btn-disabled o-60"
                        target="_blank"
                        :title="ticket.title + ' Sold Out'"
                      >
                        <span class="text">
                          {{ ticket.button_copy }}
                        </span>
                      </a>
                      <a
                        v-else
                        class="db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer"
                        :href="ticket.link"
                        target="_blank"
                        :title="ticket.title"
                        :id="ticket.id"
                      >
                        <span class="text">
                          {{ ticket.button_copy }}
                        </span>
                      </a>
                    </div>
                    <div
                      v-if="ticket.button_two.is_external_link"
                      class="relative mt3 mb3 tc"
                    >
                      <a
                        v-if="ticket.button_two.is_disabled"
                        class="db relative center w-100 pv3 btn-generic btn-disabled o-60"
                        target="_blank"
                        :title="ticket.button_two.title + ' On Sale 3/15'"
                      >
                        <span class="text">
                          {{ ticket.button_two.text }}
                        </span>
                      </a>
                      <a
                        v-else-if="ticket.button_two.is_sold_out"
                        class="db relative center w-100 pv3 btn-generic btn-disabled o-60"
                        target="_blank"
                        :title="ticket.button_two.title + ' Sold Out'"
                      >
                        <span class="text">
                          {{ ticket.button_two.text }}
                        </span>
                      </a>
                      <a
                        v-else
                        class="db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer"
                        :href="ticket.button_two.link"
                        target="_blank"
                        :title="ticket.button_two.title"
                        :id="ticket.id"
                      >
                        <span class="text">
                          {{ ticket.button_two.text }}
                        </span>
                      </a>
                    </div>
                    <div v-else class="relative mv3 tc">
                      <router-link
                        class="db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer"
                        :title="ticket.button_two.title + ' On Sale 3/15'"
                        :to="ticket.button_two.link"
                      >
                        <span class="text">
                          {{ ticket.button_two.text }}
                        </span>
                      </router-link>
                    </div>
                    <div class="db relative mv4 tl" v-if="ticket.messaging_text">
                      <div
                        v-if="ticket.messaging_text"
                        class="f3 is-bureau-bold is-beige cms-content"
                        v-html="marked(ticket.messaging_text)"
                      ></div>
                      <div v-else class="f3 is-bureau-bold is-beige cms-content">
                        {{ ticket.messaging_text }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="relative pb0 pb3 ph3 ph3-ns bg-beige"
                    :class="{ 'border-yellow': index === 2, 'border-teal': index !== 2 }"
                  >
                    <div
                      class="relative mv3 mv4-ns tl is-tablet-regular is-black"
                      v-if="ticket.perks.is_published"
                    >
                      <div
                        class="f5 mt2 mb3 tl is-tablet-bold is-navy"
                        v-html="ticket.perks.text"
                      ></div>
                      <div class="db">
                        <div class="is-teal" v-if="index === -1">
                          <span class="is-table-bold b ttu is-teal" title="More perks"
                            >More Details Coming Soon!</span
                          >
                        </div>
                        <perks-dropdown v-else>
                          <template slot="perks-content">
                            <div
                              class="relative flex flex-row items-center f5 mv1 pv1"
                              v-for="(perk, index) in ticket.perks.perks_list"
                              :key="`ticket-perks-${index}`"
                            >
                              <span class="relative mr4 w4 check-container">
                                <img class="w-100" :src="perk.image" />
                              </span>
                              <div class="w-100">
                                <p class="mv0 f5" v-if="perk" v-html="perk.copy"></p>
                                <p class="mv0 f5" v-else>{{ perk.copy }}</p>
                              </div>
                            </div>
                          </template>
                        </perks-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- single day section -->
            <section
              :id="page.single_day_section.slug"
              class="relative mw9 center pt2 pb3 pv4-ns"
              v-if="page.single_day_section.is_published"
            >
              <div class="relative mb2 mb3-ns tl">
                <h2
                  class="f-page-hdr mv0 ttu is-blenny is-navy"
                  :id="page.single_day_section.slug"
                >
                  {{ page.single_day_section.title }}
                </h2>
              </div>
              <div class="row">
                <div
                  class="relative col-xs-12 col-sm-6 col-md-4 mb4"
                  v-for="(ticket, index) in page.single_day_section.tickets"
                  :key="'tix-column-' + index"
                  :id="ticket.slug"
                >
                  <div
                    class="relative pt1 pb0 ph3 ph3-ns"
                    :class="{
                      'bg-yellow border-yellow': index === 2,
                      'bg-teal border-teal': index !== 2,
                    }"
                  >
                    <div class="relative flex flex-row justify-between mv3">
                      <div
                        class="relative tl mw5 flex items-center w-50"
                        :class="{ 'w-col-lg-important': index === 2 }"
                      >
                        <div class="db w5" :class="{ 'w-col-lg-important': index === 2 }">
                          <h3
                            class="db w-100 f3 ttu is-tablet-regular"
                            :class="{ 'is-navy': index === 2, 'is-beige': index !== 2 }"
                          >
                            {{ ticket.title }}
                          </h3>
                          <span
                            v-if="ticket.sub_title"
                            class="db f4 mt2 is-tablet-regular"
                            :class="{ 'is-navy': index === 2, 'is-beige': index !== 2 }"
                            >{{ ticket.sub_title }}</span
                          >

                        </div>
                      </div>
                      <div
                        class="relative tr w-100"
                        :class="{ 'dn-important': index === 2 }"
                      >
                        <span class="f2 is-tablet-bold ttu is-beige">
                          {{ ticket.price
                          }}<span class="db ttu f5 is-tablet-regular">&nbsp;+fees</span>
                        </span>
                      </div>
                    </div>
                    <div class="relative mv3 tc">
                      <a
                        v-if="ticket.is_disabled"
                        class="db relative center w-100 pv3 btn-generic btn-disabled o-60"
                        target="_blank"
                        :title="ticket.title"
                      >
                        <span class="text">
                          {{ ticket.button_copy }}
                        </span>
                      </a>
                      <a
                        v-else-if="ticket.is_sold_out"
                        class="db relative center w-100 pv3 btn-generic btn-disabled o-60"
                        target="_blank"
                        :title="ticket.title + ' Sold Out'"
                      >
                        <span class="text">
                          {{ ticket.button_copy }}
                        </span>
                      </a>
                      <a
                        v-else
                        class="db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer"
                        :href="ticket.link"
                        target="_blank"
                        :title="ticket.title"
                        :id="ticket.id"
                      >
                      
                        <span class="text"> {{ ticket.button_copy }} </span>
                      </a>
                    </div>
                    <div class="relative mt3 mb3 tc" v-if="index === 2">
                      <a
                        class="db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer"
                        :href="ticket.button_two.link"
                        :title="ticket.button_two.title"
                        :id="ticket.id"
                      >
                        <span class="text"> {{ ticket.button_two.text }} </span>
                      </a>
                    </div>
                    <div class="relative mv4 tl" v-if="ticket.messaging_text">
                      <div class="f3 is-bureau-bold is-beige">
                        {{ ticket.messaging_text }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="relative pb0 pb3 ph3 ph3-ns bg-beige"
                    :class="{ 'border-yellow': index === 2, 'border-teal': index !== 2 }"
                  >
                    <div
                      class="relative mv3 mv4-ns tl is-tablet-regular is-black"
                      v-if="ticket.perks.is_published"
                    >
                      <div
                        class="f5 mt2 mb3 tl is-tablet-bold is-navy"
                        v-html="ticket.perks.text"
                      ></div>
                      <div class="db">
                        <perks-dropdown>
                          <template slot="perks-content">
                            <div
                              class="flex flex-row items-center f5 mv4"
                              v-for="(perk, index) in ticket.perks.perks_list"
                              :key="`perk-${perk}-${index}`"
                            >
                              <span class="relative mr4 w4 check-container">
                                <img class="w-100" :src="perk.image" />
                              </span>
                              <div class="w-100">
                                <p class="mv0 f5" v-if="perk" v-html="perk.copy"></p>
                                <p class="mv0 f5" v-else>{{ perk.copy }}</p>
                              </div>
                            </div>
                          </template>
                        </perks-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              :id="page.shuttles_section.slug"
              class="relative mw9 center pt2 pb3 pv4-ns"
              v-if="page.shuttles_section.is_published"
            >
              <div class="relative mb2 mb3-ns tl">
                <h2
                  class="f-page-hdr mv0 ttu is-blenny is-navy"
                  :id="page.shuttles_section.slug"
                >
                  {{ page.shuttles_section.title }}
                </h2>
              </div>
              <div class="row">
                <div
                  class="relative col-xs-12 col-sm-6 mb4"
                  v-for="(ticket, index) in page.shuttles_section.content"
                  :key="'tix-column-' + index"
                  :id="ticket.slug"
                >
                  <div class="relative pt1 pb0 ph3 ph3-ns bg-teal border-teal">
                    <div class="relative flex flex-row justify-between mv3">
                      <div class="relative tl mw5 flex items-center w-50">
                        <div class="db w5">
                          <h3 class="db w-100 f3 ttu is-tablet-regular is-beige">
                            {{ ticket.title }}
                          </h3>
                        </div>
                      </div>
                      <div class="relative tr w-100">
                        <span class="f2 is-tablet-bold ttu is-beige">
                          <span v-if="index === 1" class="db ttu f6 is-tablet-regular"
                            >&nbsp;starting at</span
                          >{{ ticket.price
                          }}<span class="db ttu f5 is-tablet-regular">&nbsp;+fees</span>
                        </span>
                      </div>
                    </div>
                    <div class="relative mv3 tc">
                      <a
                        v-if="ticket.is_disabled"
                        class="db relative center w-100 pv3 btn-generic btn-disabled o-60"
                        target="_blank"
                        :title="ticket.title + ' On Sale 3/15'"
                      >
                        <span class="text">
                          {{ ticket.button_copy }}
                        </span>
                      </a>
                      <a
                        v-else-if="ticket.is_sold_out"
                        class="db relative center w-100 pv3 btn-generic btn-disabled o-60"
                        target="_blank"
                        :title="ticket.title + ' Sold Out'"
                      >
                        <span class="text">
                          {{ ticket.button_copy }}
                        </span>
                      </a>
                      <a
                        v-else
                        class="db relative center w-100 pv3 btn-generic has-red-bg overflow-hidden link pointer"
                        :href="ticket.link"
                        target="_blank"
                        :title="ticket.title"
                        :id="ticket.id"
                      >
                        <span class="text">
                          {{ ticket.button_copy }}
                        </span>
                      </a>
                    </div>
                    <div class="relative mv4 tl" v-if="ticket.messaging_text">
                      <div class="f3 is-bureau-bold is-beige">
                        {{ ticket.messaging_text }}
                      </div>
                    </div>
                  </div>
                  <div class="relative pb0 pb3 ph3 ph3-ns bg-beige border-teal">
                    <div class="relative mv3 mv4-ns tl is-tablet-regular">
                      <div
                        v-if="ticket.first_text"
                        class="f5 mt2 mb3 tl is-tablet-bold is-navy cms-content"
                        v-html="marked(ticket.first_text)"
                      ></div>
                      <div
                        v-else
                        class="f4 mt2 mb3 tl ttu is-tablet-bold is-navy cms-content"
                      >
                        <p>{{ ticket.first_text }}</p>
                      </div>
                      <tix-info-dropdown>
                        <template slot="info-content">
                          <div
                            v-if="ticket.second_text"
                            class="f5 mt2 mb3 tl is-tablet-bold is-black cms-content"
                            v-html="marked(ticket.second_text)"
                          ></div>
                          <div
                            v-else
                            class="f4 mt2 mb3 tl ttu is-tablet-bold is-black cms-content"
                          >
                            <p>{{ ticket.second_text }}</p>
                          </div>
                        </template>
                      </tix-info-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <fixedbg
          :background="page.fixed_bg_section.image"
          v-if="page.fixed_bg_section.is_published"
        >
          <template slot="contents">
            <accolades-static>
              <template slot="fixed-bg-contents">
                <div class="" v-html="page.fixed_bg_section.text"></div>
              </template>
            </accolades-static>
          </template>
        </fixedbg>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from "./page-template.vue";
import PerksDropdown from "./perks-dropdown.vue";
import TixInfoDropdown from "./tix-info-dropdown.vue";
import Fixedbg from "./fixedbg.vue";
import AccoladesStatic from "./accolades-static.vue";
//var VueScrollTo = require('vue-scrollto');
export default {
  components: {
    PageTemplate,
    PerksDropdown,
    Fixedbg,
    AccoladesStatic,
    TixInfoDropdown,
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: "description", name: "description", content: this.page.seo_description },
      ],
    };
  },
  data() {
    return {
      bgOpaciy: 0,
      bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      parallax: null,
      parallax2: true,
    };
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName("tickets.markdown");
      return pageData[0];
    },
  },
  filters: {
    //
  },
  methods: {
    scrollBg: function () {
      if (window.scrollY > this.bgScrollStart) {
        if (document.body.getBoundingClientRect().top > this.scrollPos) {
          if (window.scrollY > this.bgScrollStart) {
            this.bgOpaciy = window.scrollY * 0.001;
            //console.log('SCROLL UP: ', window.scrollY, this.bgOpaciy);
          } else {
            this.bgOpacity = 0;
          }
        } else {
          this.bgOpaciy = window.scrollY * 0.001;
          //console.log('SCROLL DOWN: ', window.scrollY, this.bgOpaciy);
        }
        // saves the new position for iteration.
        this.scrollPos = document.body.getBoundingClientRect().top;
      } else {
        this.bgOpaciy = 0;
      }
      this.scrollParallax();
    },
    scrollParallax: function () {
      this.parallax = window.scrollY;
    },
    calcParallax: function (myTarget, offset, movement, positioning) {
      if (this.$refs[myTarget]) {
        this.parallax2 = false;
        if (
          this.$refs[myTarget].parentElement.getBoundingClientRect().y +
            offset +
            this.$refs[myTarget].getBoundingClientRect().height +
            movement >
            0 &&
          this.$refs[myTarget].parentElement.getBoundingClientRect().y +
            offset -
            movement <
            window.innerHeight
        ) {
          var newMovement =
            offset +
            ((this.$refs[myTarget].parentElement.getBoundingClientRect().y +
              offset +
              this.$refs[myTarget].getBoundingClientRect().height / 2 -
              window.innerHeight / 2 -
              27) /
              window.innerHeight) *
              movement;
          return "top:" + newMovement + "px;" + positioning;
        } else {
          return "display:none;";
        }
      }
    },
    scrollMeTo(refName) {
      var el = this.$refs[refName][0];
      //var top = window.pageYOffset + el.getBoundingClientRect().top - 70;
      //window.scrollTo(0, top);
      var options = {
        container: "#container",
        easing: "ease-in",
        offset: -70,
        force: true,
        cancelable: true,
        onStart: function (element) {
          //console.log('scrolling started');
        },
        onDone: function (element) {
          //console.log('scrolling is done');
        },
        onCancel: function () {
          //console.log('scrolling has been interrupted');
        },
        x: false,
        y: true,
      };
      //var cancelScroll = VueScrollTo.scrollTo(el, 500, options)
    },
  },
  created() {
    window.addEventListener("scroll", this.scrollBg);
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if (this.parallax2 !== false) this.parallax = this.parallax + 0.02;
    }),
      10;
    if (this.$route.hash) {
      setTimeout(() => {
        var anchorId = this.$route.hash;
        var element = anchorId.replace("#", "");
        document.getElementById(element).scrollIntoView();
      }, 300);
    } else {
      //console.log('else', this.$route.path );
    }
    this.$nextTick(() => {
      //
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollBg);
  },
};
</script>
